import { render, staticRenderFns } from "./TooltipIcon.vue?vue&type=template&id=b3edb86e&scoped=true"
import script from "./TooltipIcon.vue?vue&type=script&lang=js"
export * from "./TooltipIcon.vue?vue&type=script&lang=js"
import style0 from "./TooltipIcon.vue?vue&type=style&index=0&id=b3edb86e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3edb86e",
  null
  
)

export default component.exports